module.exports = require("url-parse");


//////////////////
// WEBPACK FOOTER
// external "url-parse"
// module id = 145
// module chunks = 0